import { Field } from '../../../../environments/field';
import { environment } from '../../../../environments/environment';

let token = sessionStorage.getItem('token');

export let fields: Array<Field> = [
  {
    type: 'text',
    name: 'nombre',
    label: 'Nombre',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'label',
    name: 'datos_de_usuario',
    label: 'Datos de usuario',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-12',
  },
  {
    type: 'text',
    name: 'username',
    label: 'Nombre de usuario',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'text',
    name: 'email',
    label: 'Correo Electrónico',
    value: '',
    validfield: true,
    required: true,
    width: 'col-md-6',
  },
  {
    type: 'password',
    name: 'password',
    label: 'Contraseña',
    value: '',
    validfield: true,
    required: false,
    width: 'col-md-6',
  },
  {
    type: 'password',
    name: 'repet_password',
    label: 'Repetir contraseña',
    value: '',
    validfield: true,
    required: false,
    width: 'col-md-6',
  },

  ];
